import { MutationTree } from 'vuex'

import {
  Competence,
  Country,
  Currency,
  Language,
  LegalStatus,
  Option,
  PersonTitle,
} from '@/proxy/Prequalification.CandidateMgt.FacadeClient'
import { createStoreModulePath } from '@/lib/store.utils';

import { ReferenceDataState } from './types'

export const rootReferenceDataMutationBuilder = createStoreModulePath('referenceData');
export const mutationTypes = {
  setCountryId: 'setCountryId',
  
  setCountries: 'setCountries',
  setLanguages: 'setLanguages',
  setCompetences: 'setCompetences',
  setRoles: 'setRoles',
  setTitles: 'setTitles',
  setLegalStatuses: 'setLegalStatuses',
} as const;

export const mutations: MutationTree<ReferenceDataState> = {
  [mutationTypes.setCountryId](state, value: string | undefined) {
    if (state.countryId === value) {
      return;
    }

    state.countryId = value;
  },
  [mutationTypes.setCountries](state, value: Country[]) {
    state.countries = value;
  },
  [mutationTypes.setLanguages](state, value: Language[]) {
    state.languages = value
  },
  [mutationTypes.setCompetences](state, value: Competence[]) {
    state.competences = value
  },
  [mutationTypes.setRoles](state, value: Option[]) {
    state.roles = value
  },
  [mutationTypes.setTitles](state, value: PersonTitle[]) {
    state.titles = value
  },
  [mutationTypes.setLegalStatuses](state, value: LegalStatus[]) {
    state.legalStatuses = value
  },
}
